<template>
  <v-dialog v-model="dialog" width="1050px">
    <div class="dialogBackground" :style="isMobile ? '' : 'padding: 80px'">
      <div class="titleText" :style="isMobile ? 'padding: 30px' : ''">
        List Your Digital Collection
      </div>

      <v-row v-if="token" no-gutters style="margin-top: 36px;" align="center">
        <v-col
          cols="12"
          md="5"
          :style="isMobile ? 'padding: 2px' : 'padding-right: 80px;'"
        >
          <TokenView
            :collectible="collectible"
            :moment="token.moment"
            :token="token"
          />
        </v-col>

        <v-col
          cols="12"
          md="7"
          :style="
            isMobile
              ? 'padding: 30px;'
              : 'padding-left: 80px; border-left: 1px solid #c4c4c4;'
          "
        >
          <v-row no-gutters>
            <v-col class="subtitleText mb-3" cols="12">
              Sell Price
            </v-col>

            <v-col cols="6" class="priceText">
              <v-text-field
                v-model="price"
                suffix="GM Points"
                outlined
                dense
                background-color="#c4c4c41a"
              />
            </v-col>
            <!-- <v-col class="subtitleText my-3" cols="12">
              Listing Duration
            </v-col>
            <v-col cols="12" class="durationText">
              <v-select
                v-model="duration"
                :items="durations"
                outlined
                dense
                background-color="#c4c4c41a"
              />
            </v-col> -->

            <v-col class="subtitleText my-3" cols="12">
              Fee
            </v-col>
            <v-col cols="12" class="feeContainer ma-0 pa-0">
              <v-card-actions>
                <div>Service Fee {{ serviceFeePercent * 100 }}%</div>
                <v-spacer />
                <div>{{ serviceFee }} GM Points</div>
              </v-card-actions>
            </v-col>

            <v-row class="ma-0 pa-0 mt-8" dense>
              <v-col cols="12" md="6" style="text-align: center">
                <v-btn
                  class="yellowButton ma-0"
                  text
                  height="52"
                  block
                  :loading="loading"
                  :disabled="!price || !validInput"
                  @click="listToken(token)"
                >
                  List for sale
                  <v-icon style="margin-left: 16px; width: 20px; height: 20px;">
                    mdi-arrow-right
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" style="text-align: center">
                <v-btn
                  v-if="!loading"
                  class="blackButton ma-0"
                  color="white"
                  text
                  height="52"
                  block
                  :loading="loading"
                  @click="dialog = false"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
  import MarketplaceController from '@/controllers/MarketplaceController';

  export default {
    name: 'CreateTokenListing',

    components: {
      TokenView: () => import('../components/TokenView.vue'),
    },

    props: ['collectible', 'token', 'isMobile', 'value'],

    data() {
      return {
        loading: false,
        dialog: this.value,
        price: null,
        duration: 12 * 30 * 24 * 60 * 60 * 1000,
      };
    },

    computed: {
      durations() {
        return [
          {
            text: 'Day',
            value: 24 * 60 * 60 * 1000,
          },
          {
            text: 'Week',
            value: 7 * 24 * 60 * 60 * 1000,
          },
          {
            text: 'Month',
            value: 30 * 24 * 60 * 60 * 1000,
          },
        ];
      },
      collectibleId() {
        return this.collectible.collectibleId;
      },
      tokenId() {
        return this.token.tokenId;
      },
      listingPrice() {
        return Math.round(Number(this.price));
      },
      serviceFeePercent() {
        return 0.0;
      },
      serviceFee() {
        return Math.floor(this.listingPrice * this.serviceFeePercent);
      },
      amountToReceive() {
        return this.listingPrice - this.serviceFee;
      },
      validInput() {
        var n = Math.floor(Number(this.price));
        return (
          n !== Infinity && String(n) === this.price && n > 0 && n < 10000000
        );
      },
    },

    watch: {
      value: {
        handler(val) {
          this.dialog = val;
        },
      },
      dialog: function(val) {
        this.$emit('input', val);
      },
    },

    mounted: function() {},

    methods: {
      listToken: async function() {
        try {
          this.loading = true;

          const listingPrice = Math.round(Number(this.price));
          if (!listingPrice || listingPrice <= 0) {
            return;
          }
          const date = Date.now();
          const listingData = {
            collectible: this.collectible._id,
            collectibleId: this.collectible.collectibleId,
            moment: this.token.moment._id,
            token: this.token._id,
            tokenId: this.token.tokenId,
            price: listingPrice,
            date,
            expiryDate: date + this.duration,
            serviceFee: Math.round(listingPrice * this.serviceFeePercent),
          };

          const listing = await MarketplaceController.createListing(
            listingData
          );
          this.$emit('listingComplete', listing);
        } finally {
          this.loading = false;
          this.dialog = false;
        }
      },

      handleError: function(err) {
        this.$emit('handleError', err);
      },
    },
  };
</script>

<style scoped>
  .dialogBackground {
    background: #ffffff;
    border: 1px solid #9d9d9d;
    border-radius: 30px;
  }
  .titleText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 40px;
    /* or 100% */

    color: #000000;
  }

  .subtitleText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    /* identical to box height, or 110% */

    color: #000000;
  }

  .priceText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 22px;
    /* identical to box height, or 110% */

    color: #000000;
  }

  .durationText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    /* identical to box height, or 110% */

    color: #000000;
  }

  .vDivider {
    margin-left: 80px;
    margin-right: 80px;
    width: 1px;
    height: 100%;
    background: #c4c4c4;
  }

  .collectionName {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    /* or 125% */

    color: #959595;
  }

  .tokenName {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 20px;
    /* or 83% */

    color: #000000;
  }

  .feeContainer {
    padding: 24px;
    background: rgba(196, 196, 196, 0.1);
    border-radius: 5px;
  }
</style>
